"use strict";

var _regeneratorRuntime = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _ethEnsNamehash = require("eth-ens-namehash");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var ENSRegistryContract = require('./contracts/ENSRegistry.js');

var SubdomainRegistrarContract = require('./contracts/SubdomainRegistrar.js');

var PublicResolverContract = require('./contracts/PublicResolver.js');

var FDSENS2 =
/*#__PURE__*/
function () {
  function FDSENS2(account, config) {
    _classCallCheck(this, FDSENS2);

    this.account = account;
    this.config = config;
    this.ENSRegistry = new ENSRegistryContract(this.account, config.registryAddress);
    this.SubdomainRegistrar = new SubdomainRegistrarContract(this.account, config.subdomainRegistrarAddress);
    this.PublicResolver = new PublicResolverContract(this.account, config.resolverContractAddress);
  }

  _createClass(FDSENS2, [{
    key: "registerSubdomain",
    value: function registerSubdomain(subdomain) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.SubdomainRegistrar.register((0, _web3Utils.sha3)(subdomain), confirm);
    }
  }, {
    key: "setResolver",
    value: function setResolver(subdomain) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      var addr = this.config.resolverContractAddress;
      return this.ENSRegistry.setResolver(node, addr, confirm);
    }
  }, {
    key: "setAll",
    value: function setAll(subdomain, content, multihash, name) {
      var confirm = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      var publicKey = this.account.publicKey;
      var publicKeyX = publicKey.substring(0, 66);
      var publicKeyY = "0x" + publicKey.substring(66, 130);
      return this.PublicResolver.setAll(node, this.account.wallet.address, content, multihash, publicKeyX, publicKeyY, name, confirm);
    }
  }, {
    key: "getAll",
    value: function getAll(subdomain) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      return this.PublicResolver.getAll(node, confirm);
    }
  }, {
    key: "setAddr",
    value: function setAddr(subdomain) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain); // not needed 
      // let addr = this.config.resolverContractAddress;    

      return this.PublicResolver.setAddr(node, this.account.wallet.address, confirm);
    }
  }, {
    key: "setPubkey",
    value: function setPubkey(subdomain) {
      var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      var publicKey = this.account.publicKey;
      var publicKeyX = publicKey.substring(0, 66);
      var publicKeyY = "0x" + publicKey.substring(66, 130);
      return this.PublicResolver.setPubkey(node, publicKeyX, publicKeyY, confirm);
    }
  }, {
    key: "setMultihash",
    value: function setMultihash(subdomain, multihash) {
      var confirm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      return this.PublicResolver.setMultihash(node, multihash, confirm);
    }
    /**
     * Get public key of subdoman
     * @param {string} subdomain name
     * @returns {string | boolean} returns false if invalid
     */

  }, {
    key: "getPubKey",
    value: function getPubKey(subdomain) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var node;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                node = (0, _ethEnsNamehash.hash)(subdomain + '.' + _this.config.domain);
                return _context.abrupt("return", _this.getPubKeyRaw(node));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
    /**
     * Get owner's address of subdoman
     * @param {string} subdomain name
     * @returns {string | boolean} returns false if invalid
     */

  }, {
    key: "getOwner",
    value: function getOwner(subdomain) {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var node;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                node = (0, _ethEnsNamehash.hash)(subdomain + '.' + _this2.config.domain);
                return _context2.abrupt("return", _this2.ENSRegistry.owner(node));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
    /**
     * Get public key of subdoman
     * @param {string} subdomain name
     * @returns {string | boolean} returns false if invalid
     */

  }, {
    key: "getPubKeyRaw",
    value: function getPubKeyRaw(node) {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var keyCoords, keyStr;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.PublicResolver.getPubkey(node);

              case 2:
                keyCoords = _context3.sent;
                keyStr = '04' + keyCoords[0].substring(2, 66) + keyCoords[1].substring(2, 66);

                if (!(keyStr !== "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000")) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", keyStr);

              case 8:
                return _context3.abrupt("return", false);

              case 9:
                return _context3.abrupt("return", keyStr);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
    /**
     * Get multihash of subdomain
     * @param {string} subdomain name
     * @returns {TransactionObject} transaction object
     */

  }, {
    key: "getMultihash",
    value: function getMultihash(subdomain) {
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
      return this.PublicResolver.getMultihash(node);
    }
  }]);

  return FDSENS2;
}();

var _default = FDSENS2;
exports.default = _default;
module.exports = exports.default;